import React, {useEffect, useState} from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AsyncBlock from "../../components/forms/AsyncBlock";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import PageContainer from "../../components/layout/PageContainer";
import PageSection from "../../components/layout/PageSection";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageTitle from "../../components/layout/PageTitle";
import useFetch2 from "../../hooks/useFetch2";
import HorarioForm from "./HorarioForm";
import {format} from "date-fns";

const HorarioEdit = () => {

  const navigate = useNavigate()

  const {id} = useParams()
  const {data, loading, fetchData, error} = useFetch2(Apis.PROD + '/horario-atencion/' + id, {});

  const [formatedData,setFormatedData] = useState(null)

  useEffect(()=>{
    if(data && data.fechaInicio){
      setFormatedData({...data,
        fechaInicio: format(new Date(data.fechaInicio), 'yyyy-MM-dd'),
        fechaFin: format(new Date(data.fechaFin), 'yyyy-MM-dd')
      })
    }
  },[data])

  const onUpdate = (horario) => {
    horario.id = id;
    horario.fechaInicio = horario.fechaInicio + "T00:00:00-05:00";
    horario.fechaFin = horario.fechaFin + "T00:00:00-05:00"
    horario.horaInicio = horario.horaInicio.length === 5 ? horario.horaInicio + ":00" : horario.horaInicio
    horario.horaFin = horario.horaFin.length === 5 ? horario.horaFin + ":00" : horario.horaFin
    axios.put(Apis.PROD + '/horario-atencion/update/' + id, horario)
      .then(res => {
        successToast("Horario actualizado correctamente")
        navigate('/horario')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Horarios' onClick={() => navigate('/horario')}/>
        <PageTitle title={'Horario de atención'}/>
      </PageSection>

      <PageSection>
        <AsyncBlock loading={loading} error={error}>
          <HorarioForm value={formatedData} onSubmit={(horario) => onUpdate(horario)}/>
        </AsyncBlock>

      </PageSection>
    </PageContainer>
  )
}

export default HorarioEdit;
